function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createVNode as _createVNode } from "vue";
import { computed, nextTick, reactive, onMounted, defineComponent } from "vue";
import { createNamespace } from "../utils";
import { SWIPE_KEY } from "../swipe/Swipe";
import { useParent } from "@vant/use";
import { useExpose } from "../composables/use-expose";

var _createNamespace = createNamespace("swipe-item"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

var stdin_default = defineComponent({
  name: name,
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var rendered;
    var state = reactive({
      offset: 0,
      inited: false,
      mounted: false
    });

    var _useParent = useParent(SWIPE_KEY),
        parent = _useParent.parent,
        index = _useParent.index;

    if (!parent) {
      if (process.env.NODE_ENV !== "production") {
        console.error("[Vant] <SwipeItem> must be a child component of <Swipe>.");
      }

      return;
    }

    var style = computed(function () {
      var style2 = {};
      var vertical = parent.props.vertical;

      if (parent.size.value) {
        style2[vertical ? "height" : "width"] = "".concat(parent.size.value, "px");
      }

      if (state.offset) {
        style2.transform = "translate".concat(vertical ? "Y" : "X", "(").concat(state.offset, "px)");
      }

      return style2;
    });
    var shouldRender = computed(function () {
      var _parent$props = parent.props,
          loop = _parent$props.loop,
          lazyRender = _parent$props.lazyRender;

      if (!lazyRender || rendered) {
        return true;
      }

      if (!state.mounted) {
        return false;
      }

      var active = parent.activeIndicator.value;
      var maxActive = parent.count.value - 1;
      var prevActive = active === 0 && loop ? maxActive : active - 1;
      var nextActive = active === maxActive && loop ? 0 : active + 1;
      rendered = index.value === active || index.value === prevActive || index.value === nextActive;
      return rendered;
    });

    var setOffset = function setOffset(offset) {
      state.offset = offset;
    };

    onMounted(function () {
      nextTick(function () {
        state.mounted = true;
      });
    });
    useExpose({
      setOffset: setOffset
    });
    return function () {
      var _a;

      return _createVNode("div", {
        "class": bem(),
        "style": style.value
      }, [shouldRender.value ? (_a = slots["default"]) == null ? void 0 : _a.call(slots) : null]);
    };
  }
});
export { stdin_default as default };